import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button4',
  standalone: true,
  imports: [],
  templateUrl: './button4.component.html',
  styleUrl: './button4.component.scss',
})
export class Button4Component {
  @Input() buttonText!: string;
}
